import React from 'react';
import { RefreshCw } from 'lucide-react';
import { urlPreviewUtils } from '../utils/urlPreview';

/**
 * Reusable Link Preview Component
 * Used in both EmailTemplates and CampaignModal
 */
const LinkPreviewSection = ({
  linkPreviews = {},
  loadingPreview = false,
  showLabel = true,
  label = "Link Preview",
  compact = false,
  readOnly = false
}) => {
  const hasLinkPreviews = Object.keys(linkPreviews).length > 0;

  if (!hasLinkPreviews && !loadingPreview) {
    return null;
  }

  return (
    <div className="mt-3">
      {/* Link Preview Cards */}
      {hasLinkPreviews && (
        <div className="space-y-2">
          {showLabel && (
            <p className={`${compact ? 'text-xs' : 'text-sm'} font-medium text-gray-700`}>
              {label}:
            </p>
          )}
          {Object.entries(linkPreviews).map(([url, preview]) => (
            <div key={url} className={`border border-gray-200 rounded-lg bg-gray-50 ${compact ? 'p-2' : 'p-3'}`}>
              <div className="flex items-start gap-3">
                {preview.image && (
                  <img
                    src={preview.image}
                    alt="Link preview"
                    className={`object-cover rounded flex-shrink-0 ${compact ? 'w-12 h-12' : 'w-16 h-16'
                      }`}
                  />
                )}
                <div className="flex-1 min-w-0">
                  <h4 className={`font-medium text-gray-900 truncate ${compact ? 'text-xs mb-1' : 'text-sm mb-1'
                    }`}>
                    {preview.title}
                  </h4>
                  <p className={`text-gray-600 line-clamp-2 ${compact ? 'text-xs mb-1' : 'text-xs mb-2'
                    }`}>
                    {preview.description}
                  </p>
                  <a
                    href={url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={`text-blue-600 hover:text-blue-800 hover:underline break-all ${compact ? 'text-xs' : 'text-xs'
                      }`}
                  >
                    {url}
                  </a>
                </div>
                {/*onRemovePreview && !readOnly && (
                  <button
                    type="button"
                    onClick={() => onRemovePreview(url)}
                    className="text-gray-400 hover:text-gray-600 flex-shrink-0"
                    title="Remove preview"
                  >
                    ✕
                  </button>
                )*/}
              </div>
            </div>
          ))}
        </div>
      )}

      {/* Loading State */}
      {loadingPreview && (
        <div className={`${hasLinkPreviews ? 'mt-2' : ''} ${compact ? 'text-xs' : 'text-sm'
          } text-gray-500 flex items-center gap-2`}>
          <RefreshCw className="animate-spin" size={compact ? 12 : 14} />
          Loading link preview...
        </div>
      )}
    </div>
  );
};

export default LinkPreviewSection;